import styled from "styled-components";

const Container = styled.div`
  @media screen {
    display: flex;
    justify-content: center;

    & > div {
      /* important: otherwise content might overflow */
      min-width: 0;

      padding: 0 ${({ theme }) => theme.spacing.md};

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        max-width: 60%;
      }
    }
  }
`;

const Row = styled.div`
  align-items: flex-start;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-direction: row;
  border-radius: 5px;
  transition: box-shadow 0.5s;
  @media screen (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 5px;
  }
`;

const AlignRowElements = styled.div`
  flex-direction: column;
  justify-content: center;
`;

//@ts-expect-error
const TimeSpan = styled(AlignRowElements)`
  a {
    white-space: nowrap;
  }
  margin-right: 1rem;
`;

const Duration = styled(AlignRowElements)`
  white-space: nowrap;
  text-align: right;
  color: rgba(0, 0, 0, 0.6);
  padding-right: ${({ theme }) => theme.spacing.sm};
  font-weight: bold;
  display: flex;
  flex: 0 1 auto;
`;

const Description = styled.div<{ expand: boolean }>`
  flex: 1 0 0;
  padding-left: ${({ theme }) => theme.spacing.sm};
  overflow: hidden;
  min-width: 0;
  white-space: ${({ expand }) => (expand ? "normal" : "nowrap")};
  text-overflow: ellipsis;
  cursor: pointer;
`;

export default { Container, Description, TimeSpan, Duration, Row };
